import { Dialog, DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injectable,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '@environments/environment';
import { OiqImagePreviewZoomComponent } from '@v2shared/components/image-preview-zoom/image-preview-zoom.component';
import { OiqAttachmentsUploadComponent } from './attachments-upload.component';
import { OiqAttachmentsUploadDialogResult } from './attachments-upload.models';
import { OiqAttachmentsUploadStore } from './attachments-upload.store';

@Component({
  selector: 'oiq-attachments-upload-dialog',
  templateUrl: './attachments-upload.dialog.html',
  styleUrls: ['./attachments-upload.dialog.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    OiqImagePreviewZoomComponent,
    OiqAttachmentsUploadComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OiqAttachmentsUploadDialogComponent {
  public attachments = inject(OiqAttachmentsUploadStore);
  public dialogData = inject(DIALOG_DATA, { optional: true });
  public dialogRef = inject(
    DialogRef<OiqAttachmentsUploadDialogResult, OiqAttachmentsUploadDialogComponent>
  );

  public processResults: any = null;
  public uploadUrl = `${environment.servicesUrl}/attachments/upload?type=application`;

  close(): void {
    this.dialogRef.close({
      processResults: this.processResults,
    });
  }

  onManually(): void {
    this.dialogRef.close({
      action: 'manually',
      files: this.attachments.list(),
    });
  }

  onUsingOcr(): void {
    this.attachments.ocrProcess().subscribe({
      next: response => {
        this.processResults = response;
        this.dialogRef.close({
          action: 'ocr',
          files: this.attachments.selectionList(),
          processResults: response,
        });
      },
      error: _error => {},
    });
  }
}

@Injectable({ providedIn: 'root' })
export class OiqAttachmentsUploadDialog {
  private _dialog = inject(Dialog);
  open(opts: { store?: OiqAttachmentsUploadStore; panelClass?: string }) {
    const _provider = opts.store
      ? {
          provide: OiqAttachmentsUploadStore,
          useValue: opts.store,
        }
      : {
          provide: OiqAttachmentsUploadStore,
          useFactory: () => OiqAttachmentsUploadStore,
        };
    return this._dialog.open<
      OiqAttachmentsUploadDialogResult,
      any,
      OiqAttachmentsUploadDialogComponent
    >(OiqAttachmentsUploadDialogComponent, {
      panelClass: [
        'attachments-upload-dialog',
        'ocr-upload-dialog',
        opts.panelClass || 'attachments-upload-dialog--regular',
      ],
      width: '1020px',
      maxWidth: '90vw',
      maxHeight: '960px',
      disableClose: true,
      data: {},
      providers: [_provider],
    });
  }
}
